import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// form
import { FormProvider as Form } from 'react-hook-form';

// ----------------------------------------------------------------------

FormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  methods: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  ref: PropTypes.any,
};

export default function FormProvider({ children, onSubmit, methods }) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}

const RefFormProvider = forwardRef(({ children, onSubmit, methods, ...formProps }, ref) => (
  <Form {...methods}>
    <form ref={ref} onSubmit={onSubmit} {...formProps}>
      {children}
    </form>
  </Form>
));

RefFormProvider.displayName = 'RefFormProvider';

RefFormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  methods: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  ref: PropTypes.any,
};

export { RefFormProvider };
